import { Injectable } from '@angular/core';
import { Event, NavigationEnd } from '@angular/router';
import { projectTitle } from '@app/infrastructure/constants/titles';
import { projectTitle as projectTitleRen } from '@ren/infrastructure/constants/titles';
import { environment } from '@env/environment';
import { Utility } from '@global/infrastructure/helpers/utility';
import { timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { WebSource } from '@global/infrastructure/enums/web-source.enum';

@Injectable({
  providedIn: 'root',
})
export class WebchatService {
  private waitForMethod(method) {
    let count = 0;
    const tries = 20;
    const timeToWait = 10000;
    const methodArray = method.split('.');
    return new Promise((resolve, reject) => {
      const interval = window.setInterval(() => {
        count++;
        if (count === tries) {
          window.clearInterval(interval);
          resolve(false);
        } else if (methodArray.length > 1) {
          if (
            methodArray.reduce((a, b) => {
              return a && a[b] ? a[b] : undefined;
            }, window)
          ) {
            window.clearInterval(interval);
            resolve(true);
          }
        } else if (window[methodArray[0]]) {
          window.clearInterval(interval);
          resolve(true);
        }
      }, timeToWait / tries);
    });
  }

  private setSDES(data) {
    this.waitForMethod('lpTag.sdes').then((value) => {
      if (value) {
        window.lpTag.sdes.push(data);
      }
    });
  }

  private setCustomerPolicyIdSDES(policyId: string) {
    this.setSDES({
      type: 'ctmrinfo',
      info: {
        customerId: policyId,
      },
    });
  }

  isActive() {
    return timer(0, 1000).pipe(
      takeWhile((seconds) => seconds < 10),
      map(() => !!document.querySelector('#messageUs .LPMcontainer'))
    );
  }

  trackSectionTags({
    event,
    salesChannel,
    policyId,
  }: {
    event: Event;
    salesChannel: string;
    policyId: string;
  }): void {
    const brand = environment.brand_copy.brand;
    const journey = Utility.isMta() ? projectTitle : projectTitleRen;
    const channel = (Object.values(WebSource) as string[]).includes(
      salesChannel
    )
      ? salesChannel
      : 'direct';

    const interval = setInterval(() => {
      if (window?.lpTag?.loaded) {
        clearInterval(interval);
        const pageName: string = (event as NavigationEnd).url
          .split('/')
          .filter((segment) => segment !== '')[0];
        if (journey && pageName) {
          window.lpTag.newPage(window.location.href);
          window.lpTag.section = [brand, journey, pageName];
        }
        if (policyId) {
          if (pageName !== 'load') window.lpTag.section.push(channel);
          this.setCustomerPolicyIdSDES(policyId);
        }
      }
    }, 2000);
  }
}
